import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "card", "searchInput"]
  static values = {
    searchQuery: { type: String, default: "" }
  }

  connect() {
    // Initialize search and ensure all cards are visible
    this.searchQueryValue = ""
    this.searchInputTarget.value = ""
    this.filterTeams()
  }

  search(event) {
    const query = event.target.value.toLowerCase().trim()
    this.searchQueryValue = query
    this.filterTeams()
  }

  filterTeams() {
    const cards = Array.from(this.cardTargets)
    const query = this.searchQueryValue

    // Handle visibility of cards based on search
    cards.forEach(card => {
      if (!query) {
        card.classList.remove('hidden')
      } else {
        const text = this.getSearchableText(card).toLowerCase()
        const visible = text.includes(query)
        if (visible) {
          card.classList.remove('hidden')
        } else {
          card.classList.add('hidden')
        }
      }
    })

    // Get visible cards count for empty state
    const visibleCards = cards.filter(card => !card.classList.contains('hidden'))
    this.updateEmptyState(visibleCards.length === 0)
  }

  getSearchableText(card) {
    const name = card.querySelector("h3").textContent || ""
    const details = Array.from(card.querySelectorAll('.text-lg.font-semibold'))
      .map(detail => detail.textContent)
      .join(" ")
    const games = card.querySelector('.space-y-2')?.textContent || ""
    return `${name} ${details} ${games}`
  }

  updateEmptyState(isEmpty) {
    let emptyState = this.element.querySelector('[data-empty-state]')
    if (isEmpty) {
      if (!emptyState) {
        emptyState = document.createElement('div')
        emptyState.setAttribute('data-empty-state', '')
        emptyState.className = 'col-span-full text-center py-12 text-gray-500'
        emptyState.textContent = 'No teams found matching your search.'
        this.containerTarget.appendChild(emptyState)
      }
    } else if (emptyState) {
      emptyState.remove()
    }
  }
} 